// In-house session wrapper. Replaces `vue-session` which is Vue-2-only.
//
// Stores a single encrypted JSON blob in localStorage under STORAGE_KEY,
// keyed by name. Mirrors the previous get/set/has/remove/destroy/start
// API surface that the rest of the app expects.

import * as Encode from './Encodepassword'

const STORAGE_KEY = 'cyrus-session'

function readBlob() {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    try {
        const decrypted = Encode.decryptSession(raw)
        if (!decrypted) return {}
        return JSON.parse(decrypted)
    } catch {
        return {}
    }
}

function writeBlob(session) {
    localStorage.setItem(STORAGE_KEY, Encode.encryptSession(session))
}

const required = [
    '2FAToken',
    'cache_ipClient',
    'cache_address',
    'hasGetLocation',
]

function get(name) {
    const session = readBlob()
    return name in session ? session[name] : null
}

function set(name, value) {
    const session = readBlob()
    session[name] = value
    writeBlob(session)
}

function has(name) {
    const session = readBlob()
    return session[name] !== undefined
}

function remove(name) {
    const session = readBlob()
    if (name in session) {
        delete session[name]
        writeBlob(session)
    }
}

function destroyAll() {
    localStorage.removeItem(STORAGE_KEY)
    start()
}

function destroy() {
    // Preserve the keys listed in `required` across a destroy — they hold the 2FA
    // token and cached device/location data that shouldn't be cleared on logout.
    const preserved = {}
    for (const key of required) {
        if (has(key)) preserved[key] = get(key)
    }
    destroyAll()
    writeBlob(preserved)
}

function start() {
    if (localStorage.getItem(STORAGE_KEY)) {
        localStorage.removeItem(STORAGE_KEY)
    }
    writeBlob({})
}

function exists() {
    return localStorage.getItem(STORAGE_KEY) !== null
}

export {
    get,
    set,
    has,
    remove,
    destroy,
    destroyAll,
    start,
    exists,
}
